<div class="card">
  <div class="card-body">
    <h4 class="card-title"><span class="lstick"></span>Units Status</h4>
    <div style="height: 220px;">
      <canvas
        baseChart
        height="100px"
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [options]="doughnutChartOptions"
        [legend]="doughnutChartLegend"
        [chartType]="doughnutChartType"
        [colors]="[
          {
            backgroundColor: [
            'rgb(38, 198, 218)',
            'rgb(116, 90, 242)',
            'rgb(255, 21, 160)',
            'rgb(102, 102, 0)',
            'rgb(51,51,255)'
            ]
          }
        ]"
      >
      </canvas>
    </div>
    <table class="table vm font-14">
        <ng-container *ngFor="let item of doughnutChartLabels;let i = index">
          <tr>
            <td class="b-0"  style="cursor: pointer; text-decoration: underline; " [style.color]="returnElementColor(doughnutChartLabels[i])"
             (click)="openAppropriateDialog(doughnutChartLabels[i])">{{doughnutChartLabels[i]}}</td>
            <td class="text-right font-medium b-0" >{{doughnutChartData[i]?doughnutChartData[i]:"Relay-Unit connection error"}}</td>
          </tr>
      </ng-container>
    </table>
  </div>
</div>

